module.exports = __webpack_public_path__ + "img/signpost.7b07bce3.svg";